import React, {useState, useEffect, useRef} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQueryClient, useQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API,
    ACCOUNT_API,
    PATIENTEXERCISE_API,
    PATIENTEXERCISEPRACTICE_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get, Post, Put} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    dateTimeToString,
    dateTimeToStringRequest,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue,
    objectPracticeStatus,
    practiceStatus,
    status200,
    status201
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import {isMobile} from 'react-device-detect';
import {Formik} from 'formik';
import * as yup from 'yup';
import VideoInput from '@app/components/video-input/VideoInput';

const schema = yup.object().shape({
    feedbackDoctor: yup.string().required('Trường dữ liệu không được để trống')
    // loaiNoiDung: yup
    //     .object()
    //     .nullable()
    //     .required('Trường dữ liệu không được để trống'),
});

const ExerciseDetail = () => {
    const history = useHistory();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));

    const videoRef = useRef();
    const descRef = useRef();

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin = userRole.includes(role.Admin);
    // }
    // const [exerciseId, setExerciseId] = useState(
    //     paramUrl.get('baitapId') ? paramUrl.get('baitapId') : ''
    // );
    // const [accountDoctorId, setAccountDoctorId] = useState(
    //     paramUrl.get('bacsiId') ? paramUrl.get('bacsiId') : ''
    // );

    const [exerciseId, setExerciseId] = useState(
        paramUrl.get('id') ? paramUrl.get('id') : ''
    );

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    // const {isLoading, isError, error, data, refetch} = useQuery(
    //     ['exerciseData', valueSearch, page, pageSize],
    //     () => {
    //         let model = {
    //             Keyword: valueSearch ? valueSearch : '',
    //             PageIndex: page,
    //             PageSize: pageSize,
    //             DiseaseId:
    //                 diseaseId && diseaseId.target && diseaseId.target.value
    //                     ? diseaseId.target.value.value
    //                     : ''
    //         };

    //         return Get(EXERCISE_API.GET_PAGING, null, model);
    //     }
    // );

    // const exerciseItem = useQuery(
    //     ['exercisePatientData'],
    //     () => Get(EXERCISE_API.GET_ITEM, exerciseId),
    //     {enabled: !!exerciseId}
    // );

    // const accountDoctorItem = useQuery(
    //     ['doctorPatientData'],
    //     () => Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, accountDoctorId),
    //     {enabled: !!accountDoctorId}
    // );

    // const lstPatientExerciseItem = useQuery(
    //     ['patientExerciseData'],
    //     () => {
    //         var model = {
    //             AccountPatientId: inforAccount.id,
    //             AccountDoctorId: accountDoctorId,
    //             ExerciseId: exerciseId
    //         };
    //         return Get(PATIENTEXERCISE_API.GET_PAGING, null, model);
    //     },
    //     {
    //         // don’t even start this query until we have the patient’s account
    //         enabled: !!inforAccount.id
    //     }
    // );

    const exerciseItem = useQuery(
        ['exerciseDetailData'],
        () => Get(EXERCISE_API.GET_ITEM, exerciseId),
        {enabled: !!exerciseId}
    );

    const isLoading = exerciseItem.isLoading ? true : false;
    const isError = exerciseItem.isError ? true : false;
    const error = exerciseItem.isError ? exerciseItem.error : null;

    let videoLink = '';
    if (exerciseItem && exerciseItem.data) {
        if (isValidUrl(exerciseItem.data.videoLink)) {
            if (exerciseItem.data.videoLink.includes('www.youtube.com')) {
                videoLink = exerciseItem.data.videoLink.replace(
                    'watch?v=',
                    'embed/'
                );
            }
            videoLink = exerciseItem.data.videoLink;
        } else {
            videoLink = BaseGatewayImage + exerciseItem.data.videoLink;
        }
    }

    return (
        <div className="container-fluid">
            {isLoading || isError ? (
                <h3 className="card-title">Chưa load được chi tiết</h3>
            ) : (
                <>
                    <div id="practice-tab-content" className="tab-content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h4>
                                            <i className="fas fa-dumbbell text-primary" />{' '}
                                            {exerciseItem && exerciseItem.data
                                                ? exerciseItem.data.name
                                                : ''}
                                        </h4>
                                    </div>
                                    <div
                                        className="card-body"
                                        id="exercise-details"
                                    >
                                        {!isMobile ? (
                                            <div className="row">
                                                <div className="col-12">
                                                    {videoLink && (
                                                        <div
                                                            ref={videoRef}
                                                            className="float-md-end w-100 w-md-50 ms-md-3 mb-3"
                                                            style={{
                                                                maxWidth: '45%'
                                                            }}
                                                        >
                                                            <ReactPlayer
                                                                url={videoLink}
                                                                width="100%"
                                                                height="auto"
                                                                controls
                                                                muted
                                                                loop
                                                                playing
                                                                playsinline
                                                            />
                                                        </div>
                                                    )}

                                                    <div
                                                        ref={descRef}
                                                        className="html-dangerouslySetInner"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                exerciseItem
                                                                    ?.data
                                                                    ?.description ||
                                                                ''
                                                        }}
                                                    />

                                                    <p>
                                                        <i className="fas fa-user-md text-info" />{' '}
                                                        Được điều trị bởi: (Tên bác sĩ){' '}
                                                    </p>

                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lần cần tập mỗi buổi:{' '}
                                                        {
                                                            exerciseItem?.data
                                                                ?.practiceCountMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            exerciseItem?.data
                                                                ?.practiceCountMaximum
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mobile-desc">
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: exerciseItem
                                                                    ?.data
                                                                    ?.description
                                                            }}
                                                        />
                                                    </div>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số cần lần tập:{' '}
                                                        {
                                                            exerciseItem?.data
                                                                ?.practiceCountMinimum
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            exerciseItem?.data
                                                                ?.practiceCountMaximum
                                                        }
                                                    </p>
                                                </div>
                                                <div className="col-md-6 align-self-start">
                                                    {videoLink ? (
                                                        <div className="player-wrapper">
                                                            <ReactPlayer
                                                                key={videoLink}
                                                                url={videoLink}
                                                                className="react-player"
                                                                width="100%"
                                                                height="100%"
                                                                controls
                                                                playing
                                                                muted
                                                                loop
                                                                playsinline
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="videoLink-placeholder bg-light d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: 200,
                                                                borderRadius: 5
                                                            }}
                                                        >
                                                            <p>
                                                                <i className="fas fa-videoLink fa-2x mb-2" />
                                                                <br />
                                                                'Xem videoLink
                                                                hướng dẫn ở đây'
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Quay lại
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ExerciseDetail;
